<div class="row">
	<strong class="h4">Live Activity Dashboard</strong>
	<div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">Total Online</p>
				<h4>{{ onlineUsers.length }}</h4>
				<small class="text-muted">of {{ totalUsers }} users</small>
			</div>
		</div>
	</div>

	<div class="col-md-3">
		<div class="card card-animate card-blue">
			<div class="card-body">
				<p class="text-muted mb-0">Dials Today</p>
				<h4>{{ totalDials }}</h4>
				<small class="text-muted">across all callers</small>
			</div>
		</div>
	</div>

	<div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">Appointments</p>
				<h4>{{ appointmentsToday }}</h4>
				<small class="text-muted">today</small>
			</div>
		</div>
	</div>

	<!-- <div class="col-md-2">
		<div class="card card-animate card-orange">
			<div class="card-body">
				<p class="text-muted mb-0">Idle Alerts</p>
				<h4 class="text-warning"></h4>
			</div>
		</div>
	</div> -->

	<div class="col-md-3">
		<div class="card card-animate card-red">
			<div class="card-body">
				<p class="text-muted mb-0">Pending QC</p>
				<h4 class="text-danger">{{ totalLeadsQC }}</h4>
				<small class="text-muted">today</small>
			</div>
		</div>
	</div>

	<!-- <div class="col-md-2">
		<div class="card card-animate card-red">
			<div class="card-body">
				<p class="text-muted mb-0">Reschedules</p>
				<h4></h4>
			</div>
		</div>
	</div> -->
</div>

<div class="card">
	<div class="cc-card">
		<div class="card-header d-flex justify-content-between align-items-center">
			<div>
				<h5 class="mb-0">Currently Online Users</h5>
				<small class="text-muted">Monitor activity in real time</small>
			</div>

			<div class="user-filter">
				<span class="filter-chip" [class.active]="selectedFilter === 'ALL'" (click)="setFilter('ALL')"> All ({{ onlineUsers.length }}) </span>

				<span class="filter-chip" [class.active]="selectedFilter === 'CAL'" (click)="setFilter('CAL')"> Caller ({{ getCount("CAL") }}) </span>

				<span class="filter-chip" [class.active]="selectedFilter === 'CUS'" (click)="setFilter('CUS')"> Customer ({{ getCount("CUS") }}) </span>
			</div>
		</div>

		<div class="table-responsive">
			<table class="cc-table">
				<thead>
					<tr>
						<th>User</th>
						<th class="text-center">Campaign</th>
						<th>Last Action</th>
						<th class="text-center num">Dials</th>
						<th class="text-center">Talk Time</th>
						<th class="text-center">Last Call</th>
						<th class="text-center num">Appts</th>
						<th>Idle</th>
					</tr>
				</thead>

				<tbody>
					<tr *ngFor="let user of filteredUsers" class="clickable-row" (dblclick)="openActionsModal(actionsModal, user)">
						<td class="user-cell">
							<div class="d-flex align-items-center">
								<div class="avatar" [ngStyle]="{ 'background-color': getAvatarColor(user.full_name) }">
									{{ getInitials(user.full_name) }}
								</div>

								<div class="d-flex flex-column ms-2" style="line-height: 1.3">
									<strong>{{ user.full_name }}</strong>

									<small class="text-muted">
										{{ user.signin_time | utcToLocal }}
									</small>

									<span [class]="getUserTypeClass(user.portal)" style="width: fit-content">
										{{ user.portal == "ADM" ? "Admin" : user.portal == "CUS" ? "Customer" : user.portal == "CAL" ? "Caller" : "-" }}
									</span>
								</div>
							</div>
						</td>

						<td>
							<span [ngClass]="{ 'dash-center': !user.campaign }">{{ user.campaign || "-" }}</span>
						</td>

						<td>
							<div class="d-flex flex-column" style="line-height: 1.3">
								<span>{{ user.action_description }}</span>
								<small class="text-muted">
									{{ user.last_action_time | utcToLocal }}
								</small>
							</div>
						</td>

						<td class="num">
							<span [ngClass]="{ 'dash-center': !user.dials }">
								{{ user.dials || "-" }}
							</span>
						</td>

						<td>{{ user.talkTime }}</td>

						<td>
							<ng-container *ngIf="user.lastCall; else noCall">
								<div class="d-flex flex-column" style="line-height: 1.3">
									<span>{{ user.lastCall.startTime | utcToLocal: "short" }}</span>
									<small [ngClass]="{'text-success': user.lastCall.result === 'Call connected', 'text-muted': user.lastCall.result !== 'Call connected'}">{{ user.lastCall.result || "-" }}</small>
								</div>
							</ng-container>
							<ng-template #noCall>
								<span class="dash-center">-</span>
							</ng-template>
						</td>

						<td class="num">
							<span [ngClass]="{ 'dash-center': !user.appointments }">
								{{ user.appointments || "-" }}
							</span>
						</td>

						<td>
							<div class="d-flex align-items-center" [ngClass]="getInactivityClass(user.date_time)">
								<span class="idle-circle"></span>
								<span>{{ user.date_time | dateAgo }}</span>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="cc-foot">{{ onlineUsers.length }} online · {{ totalDials }} dials · {{ appointmentsToday }} appointments</div>
	</div>

	<ng-template #actionsModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title">User Actions History</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
		</div>
		<div class="modal-body">
			<!-- Componente que muestra las acciones del usuario -->
			<app-user-actions [user_id]="selectedUserId" [userInfo]="userInfo" [showTitle]="false" [showName]="true"> </app-user-actions>
		</div>
	</ng-template>
</div>
